import React, { useEffect, useState } from "react";
import "./HeaderLanding.css";
import { useSelector, useDispatch } from "react-redux";
import { updateLoggedInUserDetails } from "../../store/slices/loggedInUserDetailsSlice";
import logo from "../../Components/logo.png";
import { Link } from "react-router-dom";
import axios from "axios";
import Currency from "../../Assets/CurrencyConverter.png";
import CurrencyConversionScreen from "../../Pages/CurrencyConversion/CurrencyConversion";

const HeaderLanding = ({ fetchUserDetails, setFetchUserDetails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [apiVersion, setApiVersion] = useState(
    () => localStorage.getItem("apiVersion") || "v2"
  );
  const [sessionTimeLeft, setSessionTimeLeft] = useState(null);
  const dispatch = useDispatch();
  const loggedInUserDetails = useSelector(
    (state) => state.loggedInUserDetails.loggedInUserDetails
  );

  useEffect(() => {
    getLoggedInUserDetails();
  }, []);

  useEffect(() => {
    const expiry = localStorage.getItem("sessionExpiry");
    if (!expiry) return;

    const tick = () => {
      const remaining = Math.floor((parseInt(expiry, 10) - Date.now()) / 1000);
      if (remaining <= 0) {
        localStorage.clear();
        window.location.href = "/";
      } else {
        setSessionTimeLeft(remaining);
      }
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (fetchUserDetails) {
      const reqBody = {
        // clientId: 1,
      };
      const headers = {
        "Content-Type": " application/json",
        Authorization: localStorage.getItem("AuthToken"),
      };
      axios
        .post(
          "https://api.aeroprime.in/crm-service/payment/getClientCredits",
          reqBody,
          { headers }
        )
        .then((response) => {
          // dispatch(updateLoggedInUserDetails(response.data))
          // setLoggedInUserDetails(response.data);
          setFetchUserDetails(false);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.clear();
            window.location.href = "/";
          }
        });
    }
  }, [fetchUserDetails]);

  const getLoggedInUserDetails = () => {
    const reqBody = {
      // clientId: 1,
    };
    const headers = {
      "Content-Type": " application/json",
      Authorization: localStorage.getItem("AuthToken"),
    };
    axios
      .post(
        "https://api.aeroprime.in/crm-service/payment/getClientCredits",
        reqBody,
        { headers }
      )
      .then((response) => dispatch(updateLoggedInUserDetails(response.data)))
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.clear();
          window.location.href = "/";
        }
      });
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  }
  const handleCloseModal = () => {
    setIsModalOpen(false);

  };

  return (
    <header>
      <div className="header-body-landing">
        <div className="logo-container">
          <Link to="/">
            <img className="logo" src={logo} alt="logo" />
          </Link>
        </div>
        <nav className="navbar">
          <ul>
            <li className="list">
              <a href="/">Flight Search</a>
            </li>

            {((loggedInUserDetails?.role !== "admin" &&
              (loggedInUserDetails?.can_view_mis_report === 1 ||
                loggedInUserDetails?.can_view_top_up_report === 1)) ||
              (loggedInUserDetails?.role === "admin" &&
                (loggedInUserDetails?.can_deactviate_agent_booking_report ===
                  1 ||
                  loggedInUserDetails?.can_deactviate_agent_ledger_report ===
                  1))) && (
                <li className="list">
                  <a href="/Reports">Reports</a>
                </li>
              )}
            <li className="list">
              <a href="/Agents">Agents</a>
            </li>
            {loggedInUserDetails?.role === "admin" && (
              <li className="list">
                <a href="/Admins">Admin</a>
              </li>
            )}
            <li className="list">
              <a href="/bookingsHistory">Booking History</a>
            </li>
            {loggedInUserDetails?.role === "admin" && (
              <li className="list">
                <a href="/lookToBook">L2B Insights</a>
              </li>
            )}
            {loggedInUserDetails?.can_do_pnr_management === 1 && (
              <li className="list">
                <a href="/SearchPNR">Search PNR</a>
              </li>
            )}
            {loggedInUserDetails?.role !== "admin" && (
              <li className="list">
                <a href="/availableBalance">Current Balance</a>
              </li>
            )}
            {loggedInUserDetails?.role === "admin" && (
              <li className="list nav-more-item">
                <span className="nav-more-trigger">
                  More <span className="nav-more-arrow">▾</span>
                </span>
                <ul className="nav-dropdown-menu">
                  <li><a href="/auditLogs">Audit Logs</a></li>
                  <li><a href="/fareRules">Fare Rules</a></li>
                  <li><a href="/markupRules">Markup Rules</a></li>
                  <li><a href="/dummyConfig">Dummy Config</a></li>
                  <li><a href="/availableAirlines">Available Airlines</a></li>
                  <li className="nav-api-version-item">
                    <span className="nav-api-version-label">API Version</span>
                    <div className="nav-api-version-toggle">
                      {["v2", "v3"].map((v) => (
                        <button
                          key={v}
                          className={`nav-api-version-btn${apiVersion === v ? " active" : ""}`}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            setApiVersion(v);
                            localStorage.setItem("apiVersion", v);
                          }}
                        >
                          {v.toUpperCase()}
                        </button>
                      ))}
                    </div>
                  </li>
                </ul>
              </li>
            )}
              {/* <li className="list">
                <a href="/ProGroup">Pro Group</a>
              </li> */}
            
          </ul>
        </nav>
        
        <div className="header-right">
          <div className="nav-username">
            {loggedInUserDetails?.emailId && (
              <>
                <span>Welcome {' '}</span>
                <span1>{loggedInUserDetails?.name ?? loggedInUserDetails?.emailId}</span1>
              </>
            )}
          </div>
          {sessionTimeLeft !== null && (
            <div className={`session-timer${sessionTimeLeft <= 300 ? " session-timer--warning" : ""}`}>
              <span className="session-timer-icon">⏱</span>
              <span>
                {String(Math.floor(sessionTimeLeft / 60)).padStart(2, "0")}:{String(sessionTimeLeft % 60).padStart(2, "0")}
              </span>
            </div>
          )}
          <div className="nav-logout">
            <button
              className="logout-btn"
              onClick={() => {
                localStorage.clear();
                window.location.href = "/";
              }}
            >
              Logout
            </button>
            {loggedInUserDetails?.role === "admin" && (
              <button className="Currency-btn" onClick={() => handleOpenModal()}>
                <img className="currency-logo" src={Currency} alt="logo" />
              </button>
            )}

            {isModalOpen && (
              <CurrencyConversionScreen
                open={isModalOpen}
                onClose={handleCloseModal}
              // adminDetails={selectedUserInfo} // Pass the selected admin details here
              // selectedAdminDetails={selectedAdminDetails}
              // setSelectedAdminDetails={setSelectedAdminDetails}
              />
            )}



          </div>
        </div>
      </div>

    </header>
  );
};

export default HeaderLanding;
